import styled from "styled-components";

// Mirrors EmployeeSkillsBridgerV2.styles.js's scale footer visually — kept as
// local styles rather than a cross-module import since it's page chrome, not
// a shared leaf component (unlike ProficiencyBar, which is imported directly).

export const ScaleFooterStyled = styled.div`
  flex-shrink: 0;
  padding: 12px 24px;
  border-top: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  background: ${(p) => p.theme?.colors?.light ?? "#F7F7F7"};
`;

export const ScaleHeadingStyled = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
  margin-bottom: 8px;
`;

export const ScaleItemsRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const ScaleItemTextStyled = styled.span`
  font-size: 12px;
  color: ${(p) => p.theme?.colors?.dark ?? "#2B3034"};
`;
